import { useState } from "react";
const useComplexState = (initialState)=>{
    const [complexState, setComplexState] = useState(initialState);
    const setKeyData = (key, data)=>{
        setComplexState((prevState)=>({
                ...prevState,
                [key]: data
            }));
    };
    return {
        state: complexState,
        setKeyData,
        setAllData: setComplexState
    };
};
export default useComplexState;

//# sourceMappingURL=useComplexState.js.map